import { ACTIONS } from './actionTypes'


export const setCloseNavBar = (close) => (
  { type: ACTIONS.SET_CLOSE_NAVBAR, close }
);



// WEBPACK FOOTER //
// ./src/redux/action/navbar_actions.js